import type { CombatState } from '../../types/interfaces';

/** O que a tela de combate mostra ao fim de um nível de missão. */
export type MissionView = 'portal' | 'completed' | 'failed';

/**
 * null = não é missão, ou o combate ainda não terminou (overlay normal da batalha).
 * O nível é do time: basta um jogador vivo (em equipe, quem caiu segue junto).
 * Vitória com portal aberto pelo servidor → 'portal'; vitória sem portal (último
 * nível) → 'completed'; time inteiro caído (ou eu abandonei) → 'failed'.
 */
export function missionView(combat: CombatState, myEntityId: string): MissionView | null {
  if (!combat.mission) return null;
  if (combat.phase !== 'FINISHED' && combat.phase !== 'ABANDONED') return null;

  if (!combat.entities[myEntityId]) return 'failed';
  const teamAlive = Object.values(combat.entities).some(e => e.team === 'player' && e.hp > 0);
  if (!teamAlive) return 'failed';
  return combat.mission.portal ? 'portal' : 'completed';
}

/**
 * O combate terminou mas a conexão precisa continuar: nível de missão vencido
 * com portal aberto — os jogadores ainda andam até o portal (MOVE pós-vitória).
 */
export function keepSocketOpen(combat: Pick<CombatState, 'phase' | 'mission'>): boolean {
  return combat.phase === 'FINISHED' && !!combat.mission?.portal;
}
